import React from 'react';
import PropTypes from 'prop-types';
import ControlButtons from './ControlButtons';
import { getSlidesByCountry } from './slides/SlideUtils';

const audioBoxStyle = {
    width: '325px',
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
};

const audioBoxDivStyle = {
    width: '155px',
    position: 'absolute',
    left: '52%',
    transform: 'translateX(-50%)',
    height: '60px',
};

class PresentationContainer extends React.Component {
    constructor(props) {
        super(props);
        this.audio = React.createRef();
        this.slide = React.createRef();

        this.state = {
            currentSlide: 1,
            // Slides & audio would be rendered depending upon the country [Presentation may not be the same for all countries]
            slides: getSlidesByCountry(props.country),
        };
    }

    scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop);

    audioPlay = () => {
        this.audio.current.play();
        // uncomment to fast forward during development
        // this.audio.current.currentTime = 75;
    };

    audioPause = () => {
        this.audio.current.pause();
    };

    audioReplay = () => {
        this.audio.current.pause();
        this.audio.current.currentTime = 0;
        this.audio.current.load();
        this.audio.current.play();
    };

    // when audio file has been completely played.
    // eslint-disable-next-line no-unused-vars
    onAudioCompletion = (data) => {
        // if all previous slides had been watched in its completeness,
        // then only increase the slidesWatched
        if (this.state.currentSlide === this.props.slidesWatched + 1) {
            this.props.setSlidesWatched(this.state.currentSlide);
            // mark the training completed as true, only if all slides have been
            // watched completely.
            if (this.state.currentSlide === this.state.slides.totalSlides) {
                this.props.onTrainingCompletion();
            }
        }
    };

    audioSetter = (slideNumber) => {
        if (this.audio.current) {
            this.audio.current.pause();
            const { audioPath } = this.state.slides;
            this.audio.current.src = `${audioPath}/Slide ${
                slideNumber - 1
            }.mp3`;
            if (this.audio.current.onended === null)
                this.audio.current.addEventListener(
                    'ended',
                    this.onAudioCompletion
                );
        }
    };

    nextSlide = () => {
        this.scrollToRef(this.slide);
        this.audioSetter(this.state.currentSlide + 1);
        this.audioPlay();
        this.setState({ currentSlide: this.state.currentSlide + 1 });
    };

    previousSlide = () => {
        this.audioSetter(this.state.currentSlide - 1);
        this.setState({ currentSlide: this.state.currentSlide - 1 });
    };

    render() {
        // if training is already completed, person can skip the presentation
        // todo - why add 1
        const maxSkippableSlides = this.props.hasCompletedTrainingPreviously
            ? this.state.slides.totalSlides
            : Math.min(
                  this.props.slidesWatched + 1,
                  this.state.slides.totalSlides
              );

        const Slides = this.state.slides.component;

        return (
            <div className="w-full mt-4 overflow-hidden">
                <div className="slideContainer">
                    <audio
                        className="focus:outline-none"
                        ref={this.audio}
                        controls={this.state.currentSlide > 1}
                        controlsList="nofullscreen nodownload noremoteplayback foobar"
                        style={audioBoxStyle}
                        data-testid="compliance-presentation-audio"
                    >
                        <source src="" type="audio/mp3" />
                    </audio>
                    <div style={audioBoxDivStyle} className="">
                        {' '}
                    </div>

                    <div
                        className="slide h-pmob md:h-p"
                        ref={this.slide}
                        style={{ overflowY: 'auto' }}
                    >
                        <Slides
                            currentSlide={this.state.currentSlide}
                            nextHandler={this.nextSlide}
                        />
                    </div>
                    {this.state.currentSlide > 1 && (
                        <ControlButtons
                            nextHandler={this.nextSlide}
                            prevHandler={this.previousSlide}
                            currentSlide={this.state.currentSlide}
                            maxSkippableSlides={maxSkippableSlides}
                            totalSlide={this.state.slides.totalSlides}
                        />
                    )}
                </div>
                <p
                    className={
                        'flex pl-4 sm:pl-8 text-blue-900 mb-1 md:mb-0 text-sm'
                    }
                >
                    * Please go through the above presentation completely (
                    {this.state.slides.totalSlides}
                    &nbsp;slides) to enable this checkbox.
                </p>
            </div>
        );
    }
}

PresentationContainer.propTypes = {
    slidesWatched: PropTypes.number,
    setSlidesWatched: PropTypes.func,
    hasCompletedTrainingPreviously: PropTypes.bool,
    onTrainingCompletion: PropTypes.func,
    country: PropTypes.string,
};

export default PresentationContainer;
